import React, { useEffect, useState, useMemo } from "react";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { Table, Row, Col, Card, CardBody, Modal, ModalHeader, ModalBody, Container } from "reactstrap";
import { useTable, useGlobalFilter, useSortBy, usePagination } from "react-table";
import "../../../../assets/css/Finance/Style/PayrollManagement/payroll_management.css"
import { fetchData, fetchNodeData, FetchPostData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage";
import Select from "react-select";
import Loader from "pages/Separate/Loader";
import "./salary.css"
import axios from "axios";
function TableContainer({ employees = [], toggleLoading }) {
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [leaveDetails, setLeaveDetails] = useState([]); // Add at top
  const [tableData, setTableData] = useState([]);
  const isSearch = selectedEmployee && selectedYear;
  const [previousDecemberBalance, setPreviousDecemberBalance] = useState(null);
  const columns = useMemo(() => [
    {
      Header: "Sr No",
      accessor: "sr",
    },
    {
      Header: "Month",
      accessor: "month",
    },
    {
      Header: "Current Balance",
      columns: [
        { Header: "EL", accessor: "current_el" },
        { Header: "CL", accessor: "current_cl" },
        { Header: "SL", accessor: "current_sl" },
      ],
    },
    {
      Header: "Applied Leaves",
      columns: [
        {
          Header: "EL",
          columns: [
            { Header: "Approved", accessor: "approved_el" },
            { Header: "Unapproved", accessor: "unapproved_el" },
          ],
        },
        {
          Header: "CL",
          columns: [
            { Header: "Approved", accessor: "approved_cl" },
            { Header: "Unapproved", accessor: "unapproved_cl" },
          ],
        },
        {
          Header: "SL",
          columns: [
            { Header: "Approved", accessor: "approved_sl" },
            { Header: "Unapproved", accessor: "unapproved_sl" },
          ],
        },
      ],
    },
    {
      Header: "Paid Leaves",
      columns: [
        { Header: "PEL", accessor: "pel" },
        { Header: "PCL", accessor: "pcl" },
        { Header: "PSL", accessor: "psl" },
      ],
    },
    {
      Header: "Balance Left",
      columns: [
        { Header: "EL", accessor: "balance_el" },
        { Header: "CL", accessor: "balance_cl" },
        { Header: "SL", accessor: "balance_sl" },
      ],
    },
    {
      Header: "Late Punch",
      accessor: "late_punch",
    },
    {
      Header: "Net Salary",
      accessor: "net_salary",
    },
    {
      Header: "Deduction",
      accessor: "deduction",
    },
  ], []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data: tableData,
      initialState: { pageSize: 12 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { globalFilter } = state;
  const generateYearsFromDOJ = (doj) => {
    if (!doj) return [];
    const joiningYear = new Date(doj).getFullYear();
    const currentYear = new Date().getFullYear();
    const yearArray = [];
    for (let year = joiningYear; year <= currentYear; year++) {
      yearArray.push(year);
    }
    return yearArray;
  };
  const employeeOptions = useMemo(() => {
    return employees?.map(emp => ({
      value: emp.id,
      label: emp.name,
      doj: emp.date_of_joining,
      role: emp.roleid || 1,
    })) || [];
  }, [employees]);
  const handleEmployeeChange = (selectedOption) => {
    setSelectedEmployee(selectedOption);
    setSelectedYear("");
    if (selectedOption?.doj) {
      const generatedYears = generateYearsFromDOJ(selectedOption.doj);
      setYears(generatedYears);
    } else {
      setYears([]);
    }
  };
  const generateMonths = (year) => {
    return Array.from({ length: 12 }, (_, index) => {
      const date = new Date(year, index);
      return {
        monthIndex: index,
        monthNumber: index + 1,
        month: date.toLocaleString("default", { month: "long" }),
        earnedLeave: 0,
        casualLeave: 0,
        sickLeave: 0,
        usedEL: 0,
        usedCL: 0,
        usedSL: 0,
      };
    });
  };
  const fetchSalarySummary = async (userId, year) => {

    try {
      toggleLoading(true);

      const response = await fetchNodeData(
        toggleLoading,
        `salary/summary?user_id=${userId}&year=${year}`,
        secureLocalStorage.getItem("auth_token")
      );

      console.log(response)

      if (!response?.summary) return [];
      // console.log(response);

      return response.summary;
    } catch (error) {
      console.error("Salary API error:", error);
      return [];
    } finally {
      toggleLoading(false);
    }
  };
  useEffect(() => {
    if (!selectedEmployee || !selectedYear) {
      setTableData([]);
      return;
    }
    const loadSalarySummary = async () => {
      const data = await fetchSalarySummary(
        selectedEmployee.value,
        selectedYear
      );
      const formatted = data.map((item, index) => ({
        sr: index + 1,
        month: new Date(0, item.month - 1).toLocaleString("default", {
          month: "long",
        }),
        current_el: item.current_balance?.el || 0,
        current_cl: item.current_balance?.cl || 0,
        current_sl: item.current_balance?.sl || 0,
        approved_el: item.leaves?.approved_el || 0,
        unapproved_el: item.leaves?.unapproved_el || 0,
        approved_cl: item.leaves?.approved_cl || 0,
        unapproved_cl: item.leaves?.unapproved_cl || 0,
        approved_sl: item.leaves?.approved_sl || 0,
        unapproved_sl: item.leaves?.unapproved_sl || 0,
        pel: item.paid_leaves?.pel || 0,
        pcl: item.paid_leaves?.pcl || 0,
        psl: item.paid_leaves?.psl || 0,
        balance_el: item.balance_left?.el || 0,
        balance_cl: item.balance_left?.cl || 0,
        balance_sl: item.balance_left?.sl || 0,
        late_punch: item.late_punch || 0,
        net_salary: item.net_salary || 0,
        deduction: item.deduction || 0,
      }));
      setTableData(formatted);

      // ✅ Fetch Previous Year December
      const previousYear = parseInt(selectedYear) - 1;
      const previousYearData = await fetchSalarySummary(
        selectedEmployee.value,
        previousYear
      );
      const decemberData = previousYearData.find(
        (item) => item.month === 12
      );
      if (decemberData) {
        setPreviousDecemberBalance({
          el: decemberData.balance_left?.el || 0,
          cl: decemberData.balance_left?.cl || 0,
          sl: decemberData.balance_left?.sl || 0,
        });
      } else {
        setPreviousDecemberBalance(null);
      }
    };
    loadSalarySummary();
  }, [selectedEmployee, selectedYear]);
  return (
    <div>
      {/* Top Header Section */}
      <Row className="mb-3 align-items-center">
        <Col md={2}>
          {/* <div className="mt-2"> */}
          {/* <label className="form-label">Employee Name</label> */}
          <Select
            placeholder="Select Employee"
            className="basic-single"
            classNamePrefix="select"
            options={employeeOptions}
            value={selectedEmployee}
            onChange={handleEmployeeChange}
            isClearable
            isSearchable
          />
          {/* </div> */}
        </Col>
        {/* Middle: Year Selection */}
        <Col md={2}>
          <select
            className="form-select border-radius"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            disabled={!selectedEmployee}
          >
            <option value="">Select Year</option>
            {years?.map(year => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>

        </Col>
        {/* Right: Search Bar */}
        <Col md={8} className="d-flex justify-content-end align-items-center gap-3">
          {/* ✅ Previous December Closing Balance - Single Line UI */}
          {previousDecemberBalance && (
            <div className="d-flex align-items-center px-3 py-2 bg-white border rounded">
              <span className="fw-semibold text-muted me-1">
                Dec {parseInt(selectedYear) - 1} Closing Balance  →
              </span>
              <div>
                EL: <strong>{previousDecemberBalance.el}</strong> 
                {/* |
                CL: <strong>{previousDecemberBalance.cl}</strong> |
                SL: <strong>{previousDecemberBalance.sl}</strong> */}
              </div>
            </div>
          )}
        </Col>
      </Row>
      {isSearch ? (
        <div className="table-responsive">
          <Table className="table table-bordered align-middle">
            <thead className="table-light">
              {/* Row 1: Top Level Headers */}
              <tr>
                <th rowSpan="3" className="text-center align-middle">Sr No</th>
                <th rowSpan="3" className="text-center align-middle">Month</th>
                <th colSpan="3" className="text-center">Current Balance</th>
                <th colSpan="6" className="text-center">Applied Leaves</th>
                <th colSpan="3" className="text-center">Paid Leaves</th>
                <th colSpan="3" className="text-center">Balance Left</th>
                <th rowSpan="3" className="text-center align-middle">Late Punch</th>
                <th rowSpan="3" className="text-center align-middle">Net Salary</th>
                <th rowSpan="3" className="text-center align-middle">Deduction</th>
              </tr>
              {/* Row 2: Secondary Headers (Applied Leaves Breakdown) */}
              <tr>
                <th rowSpan="2" title="Earned Leave" className="text-center">EL</th>
                <th rowSpan="2" title="Casual Leave" className="text-center">CL</th>
                <th rowSpan="2" title="Sick Leave" className="text-center">SL</th>
                <th colSpan="2" title="Earned Leave" className="text-center">EL</th>
                <th colSpan="2" title="Casual Leave" className="text-center">CL</th>
                <th colSpan="2" title="Sick Leave" className="text-center">SL</th>
                <th rowSpan="2" title="Paid Earned Leave" className="text-center">PEL</th>
                <th rowSpan="2" title="Paid Casual Leave" className="text-center">PCL</th>
                <th rowSpan="2" title="Paid Sick Leave" className="text-center">PSL</th>
                <th rowSpan="2" title="Earned Leave" className="text-center">EL</th>
                <th rowSpan="2" title="Casual Leave" className="text-center">CL</th>
                <th rowSpan="2" title="Sick Leave" className="text-center">SL</th>
              </tr>
              {/* Row 3: Final Headers (Approved/Unapproved) */}
              <tr>
                <th className="text-center">App.</th>
                <th className="text-center">Unapp.</th>
                <th className="text-center">App.</th>
                <th className="text-center">Unapp.</th>
                <th className="text-center">App.</th>
                <th className="text-center">Unapp.</th>
              </tr>
            </thead>

            <style>
              {`
        .salary-row:hover td {
          background-color: #f5d0fe !important;
        }
        `}
            </style>
            <tbody>
              {tableData.length > 0 ? (
                tableData.map((row, i) => {
                  const totalLeaves =
                    (row.approved_el || 0) +
                    (row.unapproved_el || 0) +
                    (row.approved_cl || 0) +
                    (row.unapproved_cl || 0) +
                    (row.approved_sl || 0) +
                    (row.unapproved_sl || 0);
                  let bgColor = "";
                  if (totalLeaves >= 4) {
                    bgColor = "#fde2e2"; // light red
                  } else if (totalLeaves <= 1) {
                    bgColor = "#d4edda"; // light green
                  }
                  const cell = (value) => (
                    <td
                      className="text-center"
                      style={{ backgroundColor: bgColor }}
                    >
                      {value ?? "-"}
                    </td>
                  );
                  return (
                    <tr key={i} className="salary-row">
                      {cell(row.sr)}
                      {cell(row.month)}
                      {/* Current Balance */}
                      {cell(row.current_el)}
                      {cell(row.current_cl)}
                      {cell(row.current_sl)}
                      {/* Applied Leaves */}
                      {cell(row.approved_el)}
                      {cell(row.unapproved_el)}
                      {cell(row.approved_cl)}
                      {cell(row.unapproved_cl)}
                      {cell(row.approved_sl)}
                      {cell(row.unapproved_sl)}
                      {/* Paid Leaves */}
                      {cell(row.pel)}
                      {cell(row.pcl)}
                      {cell(row.psl)}
                      {/* Balance Left */}
                      {cell(row.balance_el)}
                      {cell(row.balance_cl)}
                      {cell(row.balance_sl)}
                      {/* Misc */}
                      {cell(row.late_punch)}
                      {cell(row.net_salary)}
                      {cell(row.deduction)}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="20" className="text-center p-4">
                    No data found for the selected period.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      ) : (
        <div className="card p-4 h-100">
          <Row>
            <Col className="col-12">
              <Row className="justify-content-center">
                <div className="col-md-4 d-flex flex-column align-items-center justify-content-center">

                  <img
                    src={require("../../../../assets/images/Inventory/viewImg.jpg")}
                    alt="No Data"
                    width={350}
                  />
                  <p className="text-purple fw-bold text-center lh-base mt-3">
                    📊 Salary & Leave data is available here. <br />
                    Please select <strong>Employee</strong> and <strong>Year</strong> to view records.
                  </p>
                </div>
              </Row>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
}
const SalaryLeave = () => {
  document.title = "Salary Leave | Zithas Crm";
  const [employees, setEmployees] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const toggleLoading = (loading) => {
    setLoading(loading);
  };
  useEffect(() => {
    const fetchStaff = async () => {
      setLoading(true);
      const datas = await fetchData(
        setLoading,
        "staff",
        secureLocalStorage.getItem("auth_token")
      );
      // ✅ Filter only active staff
      const activeStaff = datas?.data?.filter(
        (staff) => staff.login_access == 1
      );
      console.log(activeStaff);
      setEmployees(activeStaff || []);
      setLoading(false);
    };
    fetchStaff();
  }, []);
  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={"Human Resource"}
            breadcrumbItem={"Employee Leave Summary"}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <TableContainer
                    // columns={columns} 
                    employees={employees}
                    toggleLoading={toggleLoading}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default SalaryLeave;